import { useEffect, useRef, useState } from "react";
import MainContentWrapper from "../../../Components/MainContentWrapper";
import DashBoardCard from "../../../features/HomePage/SubComponents/DashBoardCard/DashBoardCard";
import { getAllRequestIssue } from "../../../apis/BhuMeetTeams/Oparations/requestIssue";
import TableView from "../../../ReusableComponents/TableView/TableView";
import Popup from "../../../ReusableFunctions/Popup";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import SelectComponent from "../../../ReusableComponents/SelectComponent";
import { getTelecallerTeams } from "../../../apis/adminAPIs/teams";
import DurationFilters from "../../../features/Revenue/SubComponents/DurationFilters";
import InteractiveGraph from "../../BhuMeetFinance/Orders/SubComponents/OrdersGraph";
import IssueDashboardFilter from "./issueDashboardFilter";
import search from "../../../assets/search.svg"
import dateFormat from "dateformat";
import { getAllDSPs } from "../../../apis/adminAPIs/dsp";
import { allIssueTypes } from "../../../appConstants";

const InvoicesStatCard = ({
  title,
  statNumber,
  isSelected,
  onClick,
  isDisabled,
  isArray
}) => {
  return (
    <DashBoardCard
      isDisabled={isDisabled}
      title={title}
      data={statNumber}
      onClick={onClick}
      backGround={isSelected ? "green" : undefined}
      isArray={isArray}
    />
  );
};

const InvoiceStats = ({ invoicesStats, filters, changeStatusFilter, ArrayData }) => {

  return (
    <>
      {filters &&
        <div style={{ display: "flex", columnGap: "2%", marginBottom: "10px" }}>


          <InvoicesStatCard
            title={`All`}
            statNumber={invoicesStats?.all_issue}
            isSelected={filters.Status === ""}
            onClick={() =>
              changeStatusFilter({
                Status: "",
                Query: "",
                count: invoicesStats?.all_issue,
                currentPage: 1
              })
            }
          />



          <InvoicesStatCard
            title={`Open`}
            statNumber={invoicesStats?.open_issue}
            isSelected={filters.Status === "open"}
            onClick={() =>
              changeStatusFilter({
                Status: "open",
                Query: "open",
                count: invoicesStats?.open_issue,
                currentPage: 1
              })
            }
          />



          <InvoicesStatCard
            title={`Close`}
            statNumber={invoicesStats?.close_issue}
            isSelected={filters.Status === "close"}
            onClick={() =>
              changeStatusFilter({
                Status: "close",
                Query: "close",
                count: invoicesStats?.close_issue,
                currentPage: 1
              })
            }
            isArray={ArrayData && filters.Status == 'close' ? ArrayData : null}
          />


        </div>}
    </>

  );
};



export const RequestIssueDashboard = () => {

  const navigate = useNavigate()
  const userDetails = useSelector(state => state.user?.user)

  const [formattedDate, setFormattedDate] = useState('');
  const [overviewData, setOverviewData] = useState({})
  const [allRequestIssues, setallRequestIssues] = useState([])
  const [graph, setGraph] = useState([])
  const [loading, setloading] = useState(true)
  const [allusers, setAllUsers] = useState([])
  const [dsps, setdsps] = useState([])

  const [filter, setFilter] = useState(() => {
    const getFilters = localStorage.getItem("RequestIssueFilter");
    return getFilters ? JSON.parse(getFilters) : {
      fromDate: undefined,
      toDate: undefined,
      Status: "open",
      pageSize: 15,
      count: 0,
      currentPage: 1,
      Substatus: [],
      selectedUser: undefined,
      interval: 'all',
      searchString: undefined,
      selectedDsp: [],
      issueType: ''
    };
  });

  const [openFilter, setOpenFilter] = useState(false)

  const durationOptions = [
    { id: 6, placeholder: "All", interval: "all" },
    { id: 1, placeholder: "Today", interval: "day" },
    { id: 2, placeholder: "This Week", interval: "week" },
    { id: 3, placeholder: "This Month", interval: "month" },
    { id: 4, placeholder: "This Year", interval: "year" },
    {
      id: 5,
      placeholder: "Custom",
      interval: "custom",
      cb: () => {
        console.log("Custom")
        setOpenFilter(true);
      },
    },

  ];

  useEffect(() => {
    getAllUser()
    Alldsp()

  }, [])

  const Alldsp = async () => {

    const dsps = await getAllDSPs()

    let dspOptions = dsps.dsps.map(dsp => {

      if (dsp.dsp_is_active) {
        return ({
          label: dsp.dsp_name,
          value: dsp.dsp_id,
        })
      }
    }).filter(Boolean);

    setdsps(dspOptions)

    console.log(dspOptions)
  }

  const getFormattedFromAndToDate = (interval) => {
    let formattedDate = ''
    switch (interval) {
      case 'day':
        formattedDate = `Date: ${dateFormat(
          filter.fromDate,
          "dd/mm/yyyy "
        )}`
        break;
      case "week":
        const fromDateMinusOneDay = new Date(filter.fromDate);
        fromDateMinusOneDay.setDate(fromDateMinusOneDay.getDate() - 1);
        formattedDate = `Date: ${dateFormat(fromDateMinusOneDay, "dd/mm/yyyy ")} 
            to ${dateFormat(filter.toDate, "dd/mm/yyyy ")}`;
      case "month":
      case "year":
        formattedDate = `Date: ${dateFormat(filter.fromDate, "dd/mm/yyyy ")} 
            to ${dateFormat(filter.toDate, "dd/mm/yyyy ")}`
        break;
      case "custom":
        formattedDate = `Date: ${dateFormat(filter.fromDate, "dd/mm/yyyy hh:MM TT ")} 
            to ${dateFormat(filter.toDate, "dd/mm/yyyy hh:MM TT")}`
        break;
      default:
        formattedDate = ''
    }

    setFormattedDate(formattedDate);

  }
  const [isResetting, setIsResetting] = useState(false);





  useEffect(() => {
    // If we are in a resetting state, skip calling getAllIssue

    getAllIssue();
    localStorage.setItem("RequestIssueFilter", JSON.stringify(filter));
  }, [
    filter.fromDate,
    filter.interval,
    filter.toDate,
    filter.Status,
    filter.selectedUser,
    filter.searchString,
    filter.currentPage,
    filter.issueType,
    filter.selectedDsp
  ]);
  useEffect(() => {
    if (filter.interval == 'all') {
      setFormattedDate('')
    }
  }, [filter.interval])

  const getAllUser = async () => {
    let url = userDetails.bhumeet_role == 'Admin' ? '/bhumeet_team/admin/manage_team/telecallerteam' : '/bhumeet_team/customerSuccessEngineer/requestissue/getUsers'

    getTelecallerTeams(['Admin', 'Customer support engineer'], url).then(res => {
      let formatUser = [{ label: "All", value: "" }, ...res.map(x => ({ label: x.name, value: x.id }))]

      setAllUsers(formatUser)
    })
  }

  const getAllIssue = () => {
    let role = userDetails.bhumeet_role == 'Admin' ? 'operations' : 'customerSuccessEngineer'
    console.log(filter)
    setloading(true)
    getAllRequestIssue({
      pageNumber: filter.currentPage,
      pageSize: filter.pageSize,
      Status: filter.Status,
      selectedUser: filter.selectedUser,
      fromDate: filter.fromDate,
      toDate: filter.toDate,
      interval: filter.interval,
      searchString: filter.searchString,
      selectedDsp: [filter.selectedDsp.filter(x => x.value && x.value !== '')
        .map(x => `'${x.value}'`)],
      issueType: filter.issueType ? filter.issueType.value : undefined
    }, role).then(res => {
      console.log(res)
      if (filter.Status == 'open') {
        setFilter((prev) => ({ ...prev, count: res.overviewData[0].open_issue }))
      } else if (filter.Status == 'close') {
        setFilter((prev) => ({ ...prev, count: res.overviewData[0].close_issue }))

      } else {
        setFilter((prev) => ({ ...prev, count: res.overviewData[0].all_issue }))

      }
      getFormattedFromAndToDate(filter.interval)
      setOverviewData(res.overviewData[0])
      setallRequestIssues(res.requestIssue)
      setGraph(res.getGraph)
      setloading(false)
    })
  }





  return (
    <MainContentWrapper header={"Request Issues"} rightContent={
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {/* {JSON.stringify(store)} */}

        {userDetails.bhumeet_role == 'Admin' &&

          <>
            
          </>
        }



      </div>
    } >
      <div style={{ display: "flex", marginBottom: "10px",justifyContent:"space-between" }}>
        <div>
        <div>
          <DurationFilters handleFilterChanged={(e) => {
            // console.log(e)
            setloading(true)
            setFilter((prev) => ({ ...prev, fromDate: e.fromDate, toDate: e.toDate, interval: e.interval }))

          }}
            interval={filter.interval}
            isAdmin={true}
            options={durationOptions} />
        </div>
        <div style={{ marginLeft: "10px", marginTop: "4px" }} className="date_section">
          <span>{formattedDate}</span>
        </div>

        </div>
        <div style={{display:"flex",gap:"10px"}}>
          <div>
            <SelectComponent

              controlStyle={{ height: "100%", width: "200px", minHeight: "20px", border: "none", boxShadow: "0px 2px 5px 1px #6273943d", color: "hsl(0deg 0% 20% / 64%)", fontSize: "10px" }}
              isSearchable={true}
              placeholder={"Select Category..."}
              menuPlacement={"bottom"}
              list={[{ label: "All", value: "" }].concat(allIssueTypes)}

              value={filter.issueType}
              onChange={(type) => {
                console.log(type)

                setFilter({ ...filter, issueType: type, currentPage: 1 });

              }}
            />
          </div>

          <div >


            <SelectComponent
              controlStyle={{ height: "100%", width: "200px", minHeight: "20px", border: "none", boxShadow: "0px 2px 5px 1px #6273943d", color: "hsl(0deg 0% 20% / 64%)", fontSize: "10px" }}
              isSearchable={true}
              placeholder={"Select dsps..."}
              menuPlacement={"bottom"}
              list={[{ label: "All", value: "" }].concat(dsps)}
              isMulti={true}
              value={filter.selectedDsp}
              valueContainerStyle={{
                flexDirection: "column",
                alignItems: "flex-start", // Align items to the left if needed
                // Set a maximum height so that if there are many items, a vertical scrollbar appears
                maxHeight: "36px", // Adjust this value as needed
                overflowX: "auto",  // Enable vertical scrolling
                scrollbarWidth:"thin",
                marginTop:"6px"
              }}
              className="custom-selects"
              onChange={(dsp) => {
                console.log(dsp)

                setFilter({ ...filter, selectedDsp: dsp, currentPage: 1 });

              }}
            />
          </div>
          {userDetails.bhumeet_role === 'Admin' && 
            <div>
            <SelectComponent
              controlStyle={{ height: "100%", width: "200px", minHeight: "20px", border: "none", boxShadow: "0px 2px 5px 1px #6273943d", color: "hsl(0deg 0% 20% / 64%)", fontSize: "10px" }}
              isSearchable={true}
              placeholder={"Select User..."}
              menuPlacement={"bottom"}
              list={allusers}
              value={filter.selectedUser}
              onChange={(user) => {
                // console.log(drone_model_id)

                setFilter({ ...filter, selectedUser: user });

              }}
            />
          </div>
          }
        </div>
      </div>
      <InvoiceStats
        invoicesStats={overviewData}
        filters={filter}
        // ArrayData = {callHistoryOverview}
        changeStatusFilter={(statusFiler) => {
          // console.log(statusFiler);
          setloading(true)
          setFilter({
            ...filter,
            count: statusFiler.count,
            Status: statusFiler.Status,
            currentPage: statusFiler.currentPage
          });
        }}
      />

      <InteractiveGraph
        // loading={loading}
        showZoom
        data={graph}
        title={"Periodic Issues"}
        lineType={0}
        interval={filter?.interval}
        fromDate={filter.fromDate || new Date()}
      />

      <IssueDashboardFilter open={openFilter} onFilterChange={(e) => {
        console.log(e)

        setFilter((prev) => ({ ...prev, fromDate: e.fromDate, toDate: e.toDate, interval: !e.fromDate || !e.toDate ? e.interval || filter.interval : "custom" }))
        setOpenFilter(false)
      }}
        filter={filter}
        onClose={(e) => {
          console.log(e)
          if (!filter.fromDate || !filter.toDate) {
            console.log("ALL")
            setFilter((prev) => ({ ...prev, interval: "all" }))
            setFormattedDate('')
          }

          setOpenFilter(false)
        }} />


      <div style={{ position: "relative", height: "40px", width: "40%", marginBottom: "5px" }}>
        <img src={search} alt='search icon' style={{ position: 'absolute', left: "20px", top: "10px" }} />
        <input value={filter.searchString} onChange={(e) => {
          setFilter((prev) => ({ ...prev, searchString: e.target.value, currentPage: 1 }


          ))
        }}
          placeholder='Search issue by request no,issue no.,Customer name...'
          style={{ width: "100%", height: '100%', borderRadius: "4px", border: "1px solid #BFC8D9", padding: "10px 10px 10px 60px", fontSize: "12px" }} />
      </div>


      <TableView
        onStateChange={async (changedState) => {
          const { pageNumber } = changedState;
          // console.log(changedState);
          // setCurrentPage(() => pageNumber);
          setFilter({ ...filter, currentPage: pageNumber })

        }}
        onClickRow={(row) => {

          // console.log(row)
          navigate('/issue/requestIssueDetail', { state: { issueID: row.id, IssueDetail: row } });

        }}
        isLoading={loading}
        tableContainerHeight={"75%"}
        loaderHeight={"500px"}
        columns={[
          { Header: "Request Number", accessor: "req_number", width: "10%" },
          { Header:"Customer Name",accessor:"customername",width: "10%" },
          { Header: "DSP Name", accessor: "dsp_name",width: "15%"  },
          { Header: "Type", accessor: "type",width: "25%"  },
          { Header: "Priority", accessor: "priority",width: "8%"  },
          { Header: "Status", accessor: "status",width: "8%"  },
          { Header: "Created", accessor: "date_created", isDate: true,width: "15%"  },


        ]}
        data={allRequestIssues}
        pageNumber={filter.currentPage ?? 1}
        pageSize={15}
        count={Number(filter.count)}

        

      // activities={{ onClickDelete: (coupon) => Popup.alert("WARNING", "Are you sure , you want to delete this coupon?", "WARNING"), onClickEdit: ()=>{}, canEdit: true }}
      />


    </MainContentWrapper>
  )
}